import React from 'react';
import {View} from 'react-native';

import {GetRequestResponsePayload} from '../../../../../../shared/models/api';
import {NamedStyles, useStyles} from '../../../../../../shared/hooks/styles';
import {Text} from '../../../../../../shared/components/text';
import {Links} from './links';
import {DeviceSize} from '../../../../../../shared/theme/helpers';
import {useIsDesktop} from '../../../../../../shared/hooks/useIsDesktop';

export const RequestBlock = ({
  request,
  styles,
}: {
  request: GetRequestResponsePayload | null;
  styles: NamedStyles<any>;
}) => {
  const isDesktop = useIsDesktop();
  const innerStyles = useStyles(({theme, mediaOnly}) => ({
    borderContainer: {
      paddingVertical: 8,
      paddingHorizontal: 15,
      width: '100%',
      borderRadius: 5,
      borderColor: theme.color.labelText,
      borderWidth: 1,
      minHeight: 42,
    },
    textContainer: {
      marginTop: 25,
    },
    text: mediaOnly(DeviceSize.desktop, theme.fonts.h5Light),
  }));

  return (
    <>
      <View style={innerStyles.borderContainer}>
        <Text type={isDesktop ? 'h5Light' : undefined} testID='topic-request--title'>
          {request?.topic}
        </Text>
      </View>
      <View style={[innerStyles.borderContainer, innerStyles.textContainer]} testID='topic-request--body'>
        <Text type={isDesktop ? 'h5Light' : undefined}>{request?.text}</Text>
      </View>
      <Links type='appeal' request={request} styles={styles} />
    </>
  );
};
